import { useState } from 'react';
import {
  Card,
  Container,
  Stack,
  Link,
  Typography,
  TextField,
  Select,
  MenuItem,
  Tooltip,
  IconButton,
  Button,
  Grid,
  FormControl,
  InputLabel
} from '@mui/material';
import { Icon } from '@iconify/react';
import add from '@iconify/icons-ic/add';
import remove from '@iconify/icons-ic/sharp-minus';
import { Box } from '@mui/system';
import { Link as RouterLink, useParams } from 'react-router-dom';
import BrudCrumbs from '../../components/BreadCrumbs';
import Page from '../../components/Page';
import PageTitle from '../../components/PageHeading';
import Scrollbar from '../../components/Scrollbar';

function AddEditLeads() {
  const { rowId } = useParams();
  const [masterValue, setMasterValue] = useState([{ masterValue: '' }]);
  const [refreshComp, setRefreshComp] = useState(null);
  const [loanInterested, setLoanInterested] = useState(' ');
  const [amountValue, setAmountValue] = useState('');
  const [bankPreference, setBankPreference] = useState(' ');
  const [sourceValue, setSourceValue] = useState(' ');
  const [mobileNumber, setMobileNumber] = useState('');
  const [nameValue, setNameValue] = useState('');
  const [cityName, setCityName] = useState('');

  const addMoreMasterValue = () => {
    const prevValue = masterValue;
    const obj = { masterValue: '' };
    prevValue.push(obj);
    setMasterValue(prevValue);
    setRefreshComp(new Date());
  };
  const removeMasterValue = (index) => {
    const prevValue = masterValue;
    const removedItem = prevValue.filter((elm, ind) => ind !== index);
    setMasterValue(removedItem);
    setRefreshComp(new Date());
  };
  return (
    <Page title="Kpros by Kalolytic Solutions || Leads">
      <Container maxWidth="xl">
        <Box pt={3} pb={3}>
          <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
            <PageTitle info={rowId ? 'Edit Leads' : 'Add New Leads'} />
            <Box>
              <BrudCrumbs />
            </Box>
          </Stack>

          <Card
            sx={{
              borderRadius: '20px',
              border: '1px solid #e2e8f0',
              boxShadow: '0 4px 14px rgba(0,0,0,0.03)',
              p: { xs: 2.5, md: 3.5 }
            }}
          >
            <Grid container spacing={3}>
              <Grid item xs={12} sm={6} md={4}>
                <Box className="formRowHolder fullrow">
                  <Typography
                    variant="h6"
                    className="formLabel"
                    sx={{ fontSize: 13, fontWeight: 600, color: '#637381', mb: 1 }}
                  >
                    Full Name
                  </Typography>
                  <TextField
                    fullWidth
                    inputProps={{
                      className: 'textInput'
                    }}
                    placeholder="Type name..."
                    value={nameValue}
                    onChange={(event) => setNameValue(event.target.value)}
                  />
                </Box>
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <Box className="formRowHolder fullrow">
                  <Typography
                    variant="h6"
                    className="formLabel"
                    sx={{ fontSize: 13, fontWeight: 600, color: '#637381', mb: 1 }}
                  >
                    E-Mail
                  </Typography>
                  <TextField
                    fullWidth
                    inputProps={{
                      className: 'textInput'
                    }}
                    placeholder="Type email..."
                    value={mobileNumber}
                    onChange={(event) => setMobileNumber(event.target.value)}
                  />
                </Box>
              </Grid>

              <Grid item xs={12} sm={6} md={4}>
                <Box className="formRowHolder fullrow">
                  <Typography
                    variant="h6"
                    className="formLabel"
                    sx={{ fontSize: 13, fontWeight: 600, color: '#637381', mb: 1 }}
                  >
                    Phone Number
                  </Typography>
                  <TextField
                    fullWidth
                    inputProps={{
                      className: 'textInput'
                    }}
                    placeholder="Type phone number..."
                    value={cityName}
                    onChange={(event) => setCityName(event.target.value)}
                  />
                </Box>
              </Grid>

              <Grid item xs={12} sm={6} md={4}>
                <Box className="formRowHolder fullrow">
                  <Typography
                    variant="h6"
                    className="formLabel"
                    sx={{ fontSize: 13, fontWeight: 600, color: '#637381', mb: 1 }}
                  >
                    Date of Birth
                  </Typography>
                  <TextField
                    type="date"
                    fullWidth
                    inputProps={{
                      className: 'textInput'
                    }}
                    value={cityName}
                    onChange={(event) => setCityName(event.target.value)}
                  />
                </Box>
              </Grid>

              <Grid item xs={12} sm={6} md={4}>
                <Box className="formRowHolder fullrow">
                  <Typography
                    variant="h6"
                    className="formLabel"
                    sx={{ fontSize: 13, fontWeight: 600, color: '#637381', mb: 1 }}
                  >
                    City
                  </Typography>
                  <TextField
                    fullWidth
                    inputProps={{
                      className: 'textInput'
                    }}
                    placeholder="Type city..."
                    value={cityName}
                    onChange={(event) => setCityName(event.target.value)}
                  />
                </Box>
              </Grid>

              <Grid item xs={12} sm={6} md={4}>
                <Box className="formRowHolder fullrow">
                  <Typography
                    variant="h6"
                    className="formLabel"
                    sx={{ fontSize: 13, fontWeight: 600, color: '#637381', mb: 1 }}
                  >
                    Employment Type
                  </Typography>
                  <Select
                    fullWidth
                    inputProps={{
                      className: 'textInput'
                    }}
                    value={loanInterested}
                    onChange={(e) => setLoanInterested(e.target.value)}
                  >
                    <MenuItem value=" " disabled>
                      Select
                    </MenuItem>
                    <MenuItem value="homeloan">Salaried</MenuItem>
                    <MenuItem value="educationloan">Self Employed</MenuItem>
                  </Select>
                </Box>
              </Grid>

              <Grid item xs={12} sm={6} md={4}>
                <Box className="formRowHolder fullrow">
                  <Typography
                    variant="h6"
                    className="formLabel"
                    sx={{ fontSize: 13, fontWeight: 600, color: '#637381', mb: 1 }}
                  >
                    Loan Type
                  </Typography>
                  <Select
                    fullWidth
                    inputProps={{
                      className: 'textInput'
                    }}
                    value={loanInterested}
                    onChange={(e) => setLoanInterested(e.target.value)}
                  >
                    <MenuItem value=" " disabled>
                      Select
                    </MenuItem>
                    <MenuItem value="homeloan">Home Loan</MenuItem>
                    <MenuItem value="educationloan">Education Loan</MenuItem>
                  </Select>
                </Box>
              </Grid>

              <Grid item xs={12} sm={6} md={4}>
                <Box className="formRowHolder fullrow">
                  <Typography
                    variant="h6"
                    className="formLabel"
                    sx={{ fontSize: 13, fontWeight: 600, color: '#637381', mb: 1 }}
                  >
                    Loan Amount
                  </Typography>
                  <TextField
                    type="number"
                    variant="outlined"
                    inputProps={{
                      className: 'textInput'
                    }}
                    placeholder="Type amount..."
                    fullWidth
                    value={amountValue}
                    onChange={(event) => setAmountValue(event.target.value)}
                  />
                </Box>
              </Grid>

              <Grid item xs={12} sm={6} md={4}>
                <Box className="formRowHolder fullrow">
                  <Typography
                    variant="h6"
                    className="formLabel"
                    sx={{ fontSize: 13, fontWeight: 600, color: '#637381', mb: 1 }}
                  >
                    Lead Type
                  </Typography>
                  <Select
                    fullWidth
                    inputProps={{
                      className: 'textInput'
                    }}
                    value={bankPreference}
                    onChange={(e) => setBankPreference(e.target.value)}
                  >
                    <MenuItem value=" " disabled>
                      Select
                    </MenuItem>
                    <MenuItem value="sbi">SBI</MenuItem>
                    <MenuItem value="axisbank">AXIS BANK</MenuItem>
                  </Select>
                </Box>
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <Box className="formRowHolder fullrow">
                  <Typography
                    variant="h6"
                    className="formLabel"
                    sx={{ fontSize: 13, fontWeight: 600, color: '#637381', mb: 1 }}
                  >
                    Prefered Bank
                  </Typography>
                  <Select
                    fullWidth
                    inputProps={{
                      className: 'textInput'
                    }}
                    value={sourceValue}
                    onChange={(e) => setSourceValue(e.target.value)}
                  >
                    <MenuItem value=" " disabled>
                      Select
                    </MenuItem>
                    <MenuItem value="facebook">Facebook</MenuItem>
                    <MenuItem value="callcentre">Call Centre Application</MenuItem>
                  </Select>
                </Box>
              </Grid>
            </Grid>
            <Box sx={{ mt: 3, textAlign: 'right' }}>
              <Button
                variant="contained"
                sx={{
                  backgroundColor: '#13519d',
                  color: '#fff',
                  borderRadius: '8px',
                  fontWeight: 600,
                  textTransform: 'none',
                  px: 3.5,
                  py: 1,
                  boxShadow: 'none',
                  '&:hover': {
                    backgroundColor: '#0d3b75',
                    boxShadow: 'none'
                  }
                }}
              >
                Save
              </Button>
            </Box>
          </Card>
        </Box>
      </Container>
    </Page>
  );
}
export default AddEditLeads;
